import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HTML_LANG, RTL_LANGUAGES, localeFromPath } from '../src/i18n/supported';

/**
 * Keeps the i18n language and the document language in sync with the URL prefix.
 *
 * The prefix — not localStorage — is the source of truth once a visitor lands on
 * /es/... or /ar/...; otherwise a shared link would open in whatever language
 * the recipient's browser previously cached.
 */
const LocaleSync: React.FC = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const language = localeFromPath(pathname);

  useEffect(() => {
    if ((i18n.resolvedLanguage || i18n.language || '').split('-')[0] !== language) {
      void i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  useEffect(() => {
    document.documentElement.lang = HTML_LANG[language] || language;
    document.documentElement.dir = RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
  }, [language]);

  return null;
};

export default LocaleSync;
